<template>
  <div
    :class="classes"
    :style="styles"
  >
    <div>
      <slot />
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'cBanner',
  props: {
    size: {
      type: String,
      default: 'xl',
      description: '(sm / md / xl)'
    },
    bgColor: {
      type: String,
      default: 'transparent'
    },
    alignContent: {
      type: String,
      default: 'center',
      description: '(flex-start / center / flex-end / space-between)'
    },
    isBannerVideo: {
      type: Boolean,
      default: false,
    }
  },
  setup(props) {
    const classes = computed(() => [
      'c-banner',
      `c-banner--${props.size}`,
      `c-banner--align-${props.alignContent}`,
      props.isBannerVideo ? 'c-banner--video' : ''
    ])

    const styles = computed(() => ({
      'background-color': props.bgColor
    }))

    return {
      classes, styles
    }
  }
}
</script>

<style lang="scss" scoped>
  .c-banner--video {
    @media (max-width: 767px){
      min-height: 212px !important;
    }
  }
  .c-banner {
    display: flex;
    align-items: center;
    // justify-content: center;
    position: relative;
    width: 100%;

  &>div {
    padding: 0 30px;
    width: 100%;
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    // height: 100%;
  }

  &--align-center {
    &>div {
      align-content: center;
    }
  }

  &--align-space-between {
    &>div {
      align-content: space-between;
    }
  }

  &--align-flex-end {
    &>div {
      align-content: flex-end;
    }
  }

  &--align-flex-start {
    &>div {
      align-content: flex-start;
    }
  }

  &--sm {
    min-height: 300px;
  }

  &--md {
    min-height: 600px;
  }

  &--lg,
  &--xl {
    min-height: 100vh;
  }
}
</style>
